import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WiseIdAuthServiceManager } from '../../features/sso-wise-id/controller/wise-id-auth.service-manager';
import { PermissionService } from "../../services/permission.service";
import { ProfileData, UserProfileData } from '@solverml/api';

export interface NavbarLink {
  label: string;
  iconPath: string;
  route: string;
}

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {

  user: ProfileData | null = null;
  isUserAdmin: boolean = false;

  navbarLinks: NavbarLink[] = [
    { label: 'Análisis', iconPath: 'assets/static/icons/graph.svg', route: '/analysis' },
    { label: 'Rendimiento', iconPath: 'assets/static/icons/activity.svg', route: '/statistics' },
    { label: 'Salud', iconPath: 'assets/static/icons/heart.svg', route: '/health' },
    // { label: 'Estadísticas', iconPath: 'assets/static/icons/statistics.svg', route: '/statistics' },
  ];

  constructor(
    private router: Router,
    private wiseIdAuthServiceManager: WiseIdAuthServiceManager,
    public permissionService: PermissionService
  ) { }

  ngOnInit(): void {
    const userProfile = this.wiseIdAuthServiceManager.getUserProfileSessionData();
    if (userProfile) {
      this.user = userProfile.profile;
    }
    this.isUserAdmin = this.permissionService.isAdmin();
  }

  /**
   * Comprueba si el usuario tiene permiso para navegar a una ruta específica.
   * @param route La ruta a comprobar.
   */
  canNavigate(route: string): boolean {
    switch (route) {
      case '/analysis':
        return this.permissionService.canReadAnalysis();
      case '/statistics':
        return this.permissionService.canReadPerformance();
      case '/health':
        return false;
      //return this.permissionService.canReadHealth();

      default:
        return false; // Por defecto, no se puede navegar
    }
  }

  isCurrentRoute(route: string): boolean {
    return this.router.url === route;
  }
}
